import React from "react";
import "./Header.css";

export default function Header() {
    return (
        <header className="header">
            <h1>Kortney Foley</h1>
            <p>Self-taught Full Stack developer.</p>
        </header>
    );
}
